import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import Modal from 'react-responsive-modal';
import { createModalStyles } from './styles';

const ConfirmCreate = ({ modal, setModal, handleBulkOrder, handleCreate }) => {
  return (
    <div className="custom-modal">
      <Modal
        classNames={{
          overlay: 'backgroundBlur'
        }}
        open={modal}
        onClose={() => setModal(false)}
        closeOnOverlayClick={false}
        center
        showCloseIcon={false}
        styles={createModalStyles}
      >
        <div className="align-middle align-center font-muli">
          <h2 className="uppercase text-center pb-8 font-montserrat font-bold">Confirm</h2>
          <div className="font-muli text-sm pb-12">
            <p className="font-muli text-sm pb-4">Are you looking for a Bulk Order or Single PO with multiple line items?</p>
          </div>

          <div className="flex justify-between">
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={() => setModal(false)}
              size="large"
              variant="outlined"
              rounded
            >
              Cancel
            </Button>

            <div>
              <Button
                className="max-w-none font-muli font-semibold text-gray-500 uppercase text-sm"
                onClick={handleBulkOrder}
                size="large"
                variant=" filled"
                rounded
              >
                Create bulk order
              </Button>
              <Button
                className="ml-2 max-w-none font-montserrat text-gray-500 uppercase text-sm"
                onClick={handleCreate}
                size="large"
                variant=" filled"
                rounded
              >
                Create
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmCreate;
